import {getBookmarkPresentationsByID, removeLayer, updateLayerSourceParams} from "@/helpers/ol/ol-layer-helper";
import {transformExtent} from "ol/proj";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {
    addClassBySelector,
    getBySelector,
    hideElementsBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {fromExtent} from "ol/geom/Polygon";
import {resizeDataTableFilter} from "@/components/layer/info/filter/layer-info-filter-result-component";
import {reloadFilterDataTable} from "@/helpers/datatable-filter-helper";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {Fill, Stroke, Style} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {clearBuffer} from "@/helpers/measure/measure-buffer-helper";
import {clearFilterSelectLayer} from "@/helpers/filter/filter-geometry-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {isMobile} from "@/helpers/mobile-helper.js";
import {checkApplyButton} from "@/helpers/filter/filter-settings-helper.js";


let filterLayerName = 'draw-filter'
window.activeFiltersBookmarkPresentationIDs = undefined

export function getFilterLayerName() {
    return filterLayerName
}

export function removeFilterLayer() {
    removeLayer(filterLayerName, false)
}

export function getFilterGeometryType() {
    let filterGeometry = document.querySelector( 'input[name="rdiOlDrawGeometryType"]:checked')

    // No geometry filter available
    if(!filterGeometry) {
        return
    }

    return filterGeometry.value
}

export function setFilterGeometry() {
    let filterGeometry = document.querySelector( 'input[name="rdiOlDrawGeometryType"]:checked')

    // No geometry filter available
    if(!filterGeometry) {
        return
    }

    filterGeometry = filterGeometry.value

    const bookmarkPresentation = getBookmarkPresentationsByID(getActiveFilter().BookmarkPresentationID)

    let projection = getViewProjectionName()
    if(bookmarkPresentation) {
        projection = bookmarkPresentation.Service.Projection
    }

    switch (filterGeometry) {
        case 'WITHIN':
            window.filter_geom_query_type = 'WITHIN'
            break;
        case 'BBOX':
            var extent = window.map.getView().calculateExtent();
            extent = new transformExtent(extent, getViewProjectionName(), projection)

            // console.log(extent)

            let extend = {}
            extend.bottom = extent[1]
            extend.left = extent[0]
            extend.right = extent[2]
            extend.top = extent[3]

            window.filter_geom = [
                extend.left,
                extend.bottom,
                extend.right,
                extend.bottom,
                extend.right,
                extend.top,
                extend.left,
                extend.top,
                extend.left,
                extend.bottom
            ];
            window.filter_geom_query_type = 'WITHIN'

            window.filter_geom_28992 =fromExtent(extent)
            removeFilterLayer()
            break;
        case 'INTERSECTS':
            window.filter_geom_query_type = 'INTERSECTS'
            break;
        default:
            clearFilterGeometry()
            break;
    }

}

export function setFilterSettings(value) {

    showElementsBySelector('#divActiveFilters')

    if(window.settings.ShowAllFilters === 2) {
        showElementsBySelector('#btnShowFilterLayers')
    }

    showElementsBySelector('.divFilterSwitcher')
    showElementsBySelector('#divLayerInfoFilterSettings')
    showElementsBySelector('#divLayerInfoFilterResult')

    hideElementsBySelector('#divCardFilters')

    let innerHtml = ''
    if(value !== '') {
        innerHtml = '<layer-info-filter-settings></layer-info-filter-settings>'
        setFilterResult()
    } else {
        clearFilter()
    }
    document.getElementById('divLayerInfoFilterSettings').innerHTML = innerHtml
}

export function setFilterResult() {
    const innerHtml = '<layer-info-filter-result class="d-none"></layer-info-filter-result>'
    document.getElementById('divLayerInfoFilterResult').innerHTML = innerHtml
    showElementsBySelector('layer-info-filter-switcher')
}

export function clearFilter() {
    document.getElementById('divLayerInfoFilterResult').innerHTML = ''
    document.querySelector('layer-info-filter-result-button').classList.add('d-none')
    removeFilterLayer()
    // TODO: get active filter
    // updateLayerSourceParams(getActiveFilter().BookmarkPresentationID, 'FILTER', '')
}

export function getActiveFilter() {
    const slcActiveFilter = document.getElementById('slcActiveFilter')
    if(slcActiveFilter) {
        return window.filters[slcActiveFilter.value]
    }
    return slcActiveFilter
}

export function clearActiveFilter() {
    document.getElementById('slcActiveFilter').value = ''
}

export function getActiveFilterUrl(request = 'data') {
    const activeFilter = getActiveFilter()

    let url = window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID +
        '/domain/' + activeFilter.DomainID +
        '/presentation/' + activeFilter.PresentationID  +
        '/filter/'
    if(activeFilter.FormID) {
        url += activeFilter.FormID
    } else{
        url += activeFilter.ID + '/linked'
    }

    url += '?request=' + request + '&trekking=1'

    return url
}

export function isActiveFilterLinked() {
    const activeFilter = getActiveFilter()
    return !activeFilter.FormID;

}

export function getActiveFilterFormAttributeByKey(key) {
    return getActiveFilter().form.form_attributes[key]
}

export function clearFilterGeometry() {
    delete window.filter_geom_query_type
    delete window.filter_geom
    removeFilterLayer()
    checkApplyButton()
}

export function getExportExtensions(activeFilter = null) {

    if(activeFilter === null) {
        activeFilter = getActiveFilter()
    }

    return activeFilter.Filter.filter.filter_export_extensions.filter(exportExtension => exportExtension.export_extension && exportExtension.export_extension.GroupName !== 'KaartViewer')
}

export function setActiveFilter(bookmarkPresentationID, presentationID = undefined, formID = undefined, presentationName = undefined, formName = undefined, branchID = undefined) {

    if (isMobile()) {
        hideElementsBySelector('layer-menu')
    }

    window.activeFiltersBookmarkPresentationIDs = bookmarkPresentationID

    // clearBuffer()
    clearFilterSelectLayer()
    removeFilterLayer()
    clearFilterGeometry()

    getBySelector('layer-info-filter-button').querySelector('.info-menu-btn').classList.add('active')
    hideElementsBySelector('.divFilterHelpText')
    showElementsBySelector('.divFilterSwitcher')
    hideElementsBySelector('#divCardFilters')

    showLayerInfoButton('layer-info-filter', false)

    showElementsBySelector('layer-info-filter-button')

    let filters

    if(branchID) {
        const branchItem = getBranchItemByBookmarkPresentationID(branchID)

        const bookmarkPresentationIDs = []
        branchItem.branch.map(branch => {
            bookmarkPresentationIDs.push(branch.ID)
        })

        filters = []

        window.filters.filter(filter =>
            bookmarkPresentationIDs.includes(filter.BookmarkPresentationID)
        ).map(filter => {
            if(!filters.find(f => f.form.ID === filter.form.ID)) {
                filters.push(filter)
            }
        })

    } else if(formName && presentationName) {
        filters = window.filters.filter(filter =>
            filter.PresentationName === presentationName &&
            filter.form.Name === formName
        )
    } else if(formID) {
        filters = window.filters.filter(filter =>
            filter.BookmarkPresentationID === parseInt(bookmarkPresentationID) &&
            filter.PresentationID === parseInt(presentationID) &&
            (
                filter.FormID === parseInt(formID) ||
                filter.FormLinkedID === parseInt(formID)
            )
        )
    } else if(presentationID) {
        filters = window.filters.filter(filter =>
            filter.BookmarkPresentationID === parseInt(bookmarkPresentationID) &&
            filter.PresentationID === parseInt(presentationID)
        )
    } else {

        if(bookmarkPresentationID.includes(',')) {
            filters = window.filters.filter(filter =>
                bookmarkPresentationID.split(',').map( Number ).includes(filter.BookmarkPresentationID)
            )
        } else {
            filters = window.filters.filter(filter =>
                filter.BookmarkPresentationID === parseInt(bookmarkPresentationID)
            )
        }
    }

    //// console.log(filters)

    const element = document.getElementById("slcActiveFilter")
    const divActiveFilters = document.getElementById("divActiveFilters")
    divActiveFilters.innerHTML = ''

    let filterActive
    filters.map((filter, key) => {
        let active = ''

        if(formID) {
            if(filter.FormID === parseInt(formID)) {
                active = 'active'
                filterActive = filter
            }
            if(filter.FormLinkedID === parseInt(formID)) {
                active = 'active'
                filterActive = filter
            }
        } else if(key === 0) {
            active = 'active'
            filterActive = filter
        }

        if(active) {
            setTimeout(() => {
                addClassBySelector('layer-menu-group-item[data-bookmark-presentation-id="' + filter.BookmarkPresentationID + '"] .btn-filter', 'active')
                addClassBySelector('layer-menu-group-item[data-id="' + filter.BookmarkPresentationID + '"] .btn-filter', 'active')
            }, 1000)
        }

        divActiveFilters.innerHTML += `<li class="nav-item"><a data-id="${filter.ID}" class="nav-link nav-link-filter-header cursor-pointer ${active}">${filter.form.Name}</a></li>`
    })

    let index = undefined
    element.querySelectorAll('option').forEach((element, key) => {
        if ([filterActive].includes(window.filters[key - 1]) && !index) {
            index = key
        }
    })

    if(index) {
        element.selectedIndex = (index);
    }
    setFilterSettings(element.value)
}

export function getBookmarkPresentationByActiveFilter() {
    const activeFilter = getActiveFilter()
    if(activeFilter) {
        return getBookmarkPresentationsByID(activeFilter.BookmarkPresentationID)
    }
    return null
}

export function applyFilter() {
    document.querySelector('layer-info-filter-result-button').firstChild.classList.add('font-weight-bold')
    document.querySelector('layer-info-filter-settings-button').firstChild.classList.remove('font-weight-bold')
    document.querySelector('layer-info-filter-settings').classList.add('d-none')
    // document.querySelector('layer-info-filter-switcher').classList.add('d-none')
    document.querySelector('layer-info-filter-result').classList.remove('d-none')
    document.querySelector('layer-info-filter-result-button').classList.remove('d-none')

    setFilterGeometry()
    resizeDataTableFilter()
    reloadFilterDataTable()
}

export function getFilterByKey(key) {
    return window.filters[key]
}

export function getFilterVectorLayerStyle(opacity = 0.1) {
    return new Style({
        fill: new Fill({
            color: 'rgba(255, 217, 57, ' + opacity + ')',
        }),
        stroke: new Stroke({
            color: '#ffd939',
            width: 2,
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: '#ffd939',
            }),
        }),
    })
}

export function getEmptyRequiredItems(activeFilter) {
    const emptyRequiredAttributes = []
    activeFilter?.form.form_attributes.map( (formAttribute, key) => {
        if(formAttribute.IsRequired) {
            const column = filterData.columns.find(column => column.data === formAttribute.attribute.Attribute)


            if(formAttribute.attribute.Type === 21) {
                console.log(getFilterGeometryType())
                if(getFilterGeometryType() !== 'BBOX') {
                    if (getFilterGeometryType() === '' || !window.filter_geom) {
                        console.log('must have geom is empty but required')
                        emptyRequiredAttributes.push(key)
                    }
                }
            } else {
                const element = getBySelector(`layer-info-filter-settings div[data-attribute="${column.data}"] layer-info-filter-settings-badge`)
                if (!element?.innerHTML) {
                    console.log('is empty but required')
                    emptyRequiredAttributes.push(key)
                }
            }
        }
    })

    console.log(emptyRequiredAttributes)

    return emptyRequiredAttributes
}